/**
 * 模組頁面代碼 : 1430-UI-02
 * 頁面說明 : 新增修改客戶畫面
 * @module web/modules/department/components/CustomerModal
 */

// ----- import from npm modules ----
import $ from 'jquery';
import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch} from 'react-redux';

// ----- import from local modules -----
import enumList from 'web/utils/enumList';
import {BaseComponent} from 'web/components/BaseComponent';
import {
  addDepartment,
  editDepartment,
} from 'web/redux/actions/DepartmentActions';

// ----- constants -----
import {TITLE_CUSTOMER_NEW, TITLE_CUSTOMER_EDIT} from 'web/constant';
import {showMessage} from 'web/utils/modalHelper';
import {addCustomer, editCustomer} from 'web/redux/actions/CustomerActions';
import {Typeahead, Menu, MenuItem} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import validateCoordinates from 'web/utils/validateCoordinates';
import BaseAPI from 'web/redux/actions/BaseAPI';
import store from 'web/redux/store';
const CustomerModal = React.forwardRef((props, ref) => {
  const {
    toggleCustomerAddModal,
    toggleCustomerEditModal,
    reloadDepartmentList,
    clearCustomerItem,
    mode,
    customerItem,
  } = props;
  const dispatch = useDispatch();
  const baseComponent = new BaseComponent(props);
  const [modalCustomerId, setModalCustomerId] = useState('');
  const [modalCustomerCode, setModalCustomerCode] = useState('');
  const [modalCustomerName, setModalCustomerName] = useState('');
  const [customerShortName, setCustomerShortName] = useState('');
  const [modalCity, setModalCity] = useState([]);
  const [modalDistrict, setModalDistrict] = useState([]);
  const [modalAddress, setModalAddress] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [modalPostalCode, setModalPostalCode] = useState('');
  const [modalContactName, setModalContactName] = useState('');
  const [modalContactPhone, setModalContactPhone] = useState('');
  const [modalMemo, setModalMemo] = useState('');
  const [modalFaxId, setModalFaxId] = useState('');
  const [modalEmail, setModalEmail] = useState('');

  const [cityList, setCityList] = useState([]);
  const [districtList, setDistrictList] = useState([]);

  useEffect(() => {
    const fetchCityAndDistrictData = async () => {
      const token = store.getState().auth.token;
      const res = await BaseAPI.getWithAuth('/cities', null, token);
      const cityData = res.result;
      setCityList(
        cityData.map((c) => ({cityName: c.city_name, value: c.city_id})),
      );

      setDistrictList(
        cityData
          .flatMap((c) => c.districts)
          .map((d) => ({
            cityId: d.city_id,
            districtName: d.district_name,
            value: d.district_id,
          })),
      );
    };
    const handleModalShow = () => {
      fetchCityAndDistrictData();
    };

    const handleModalHide = () => {
      resetForm(modalElement.firstChild.firstChild);
    };

    const modalElement = ref.current;

    if (modalElement) {
      modalElement.addEventListener('show.bs.modal', handleModalShow);
      modalElement.addEventListener('hide.bs.modal', handleModalHide);
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener('show.bs.modal', handleModalShow);
        modalElement.removeEventListener('hide.bs.modal', handleModalHide);
      }
    };
  }, []);

  const [modalDistrictOptions, setModalDistrictOptions] =
    useState(districtList);

  const [invalidShow, setInvalidShow] = useState('none');
  const modalIcon = mode === enumList.modalMode.new ? '#ico-plus' : '#ico-edit';
  const modalTitleText =
    mode === enumList.modalMode.new ? TITLE_CUSTOMER_NEW : TITLE_CUSTOMER_EDIT;

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    // 檢查表單是否驗證通過
    if (form.checkValidity() === false) {
      setInvalidShow('block');
      return;
    }
    form.classList.add('was-validated');

    const {isValid, errors} = validateCoordinates(latitude, longitude);

    if (!isValid) {
      form.classList.remove('was-validated');
      return showMessage(enumList.messageModalMode.error, 'error', errors);
    }

    const req = {
      customerId: modalCustomerId,
      customerCode: modalCustomerCode,
      customerName: modalCustomerName,
      customerShortName,
      postalCode: modalPostalCode,
      email: modalEmail,
      city: modalCity[0].value,
      district: modalDistrict[0].value,
      address: modalAddress,
      latitude,
      longitude,
      contactName: modalContactName,
      contactPhone: modalContactPhone,
      memo: modalMemo,
      faxId: modalFaxId,
    };
    if (mode === enumList.modalMode.edit) {
      submitEditCustomer(req);
    }
    if (mode === enumList.modalMode.new) {
      submitAddCustomer(req);
    }
  };

  const submitAddCustomer = (req) => {
    dispatch(addCustomer({customer: req})).then((res) => {
      const result = res.payload || {};
      const statusCode = result.code || '';
      if (
        typeof statusCode.isSuccessCode === 'function' &&
        statusCode.isSuccessCode()
      ) {
        showMessage(enumList.messageModalMode.info, '新增成功');
        toggleCustomerAddModal(false);
        reloadDepartmentList();
      } else {
        showMessage(
          enumList.messageModalMode.error,
          'error',
          result.message || '新增失敗',
        );

        console.error('submitAddCustomer error', res);
      }
    });
  };
  const submitEditCustomer = (req) => {
    dispatch(editCustomer({customer: req, isCoordinateOnly: false})).then(
      (res) => {
        const result = res.payload || {};
        const statusCode = result.code || '';
        if (
          typeof statusCode.isSuccessCode === 'function' &&
          statusCode.isSuccessCode()
        ) {
          showMessage(enumList.messageModalMode.info, '更新成功');
          toggleCustomerEditModal(false);
          reloadDepartmentList();
        } else {
          showMessage(
            enumList.messageModalMode.error,
            'error',
            result.message || '更新失敗',
          );
        }
      },
    );
  };

  const resetForm = (form) => {
    form.classList.remove('was-validated');
    setInvalidShow('none');
    setModalCustomerId('');
    setModalCustomerCode('');
    setModalCustomerName('');
    setCustomerShortName('');
    setModalAddress('');
    setLatitude('');
    setLongitude('');
    setModalContactName('');
    setModalEmail('');
    setModalContactPhone('');
    setModalMemo('');
    setModalFaxId('');
    setModalPostalCode('');
    setModalCity([]);
    setModalDistrict([]);
    setModalDistrictOptions(districtList);
    clearCustomerItem();
    setCityList([]);
    setDistrictList([]);
  };

  useEffect(() => {
    setModalCustomerId(customerItem ? customerItem.customerId : '');
    setModalCustomerCode(customerItem ? customerItem.customerCode : '');
    setModalCustomerName(customerItem ? customerItem.customerName : '');
    setCustomerShortName(customerItem ? customerItem.customerShortName : '');
    setModalAddress(customerItem ? customerItem.address : '');
    setLatitude(customerItem?.latitude || '');
    setLongitude(customerItem?.longitude || '');
    setModalContactName(customerItem ? customerItem.contactName : '');
    setModalContactPhone(customerItem ? customerItem.contactPhone : '');
    setModalMemo(customerItem ? customerItem.memo : '');
    setModalFaxId(customerItem ? customerItem.faxId : '');
    setModalEmail(customerItem ? customerItem.email : '');
    setModalPostalCode(customerItem ? customerItem.zipCode : '');
    if (customerItem?.cityId) {
      setModalCity(
        cityList.filter((city) => city.value === customerItem.cityId),
      );
      setModalDistrictOptions(
        districtList.filter((dis) => dis.cityId === customerItem.cityId),
      );
    }
    if (customerItem?.districtId) {
      setModalDistrict(
        districtList.filter((dis) => dis.value === customerItem.districtId),
      );
    }
  }, [customerItem, cityList, districtList]);

  return (
    <div
      ref={ref}
      className="modal fade"
      id="modalCustomer"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalCustomerLabel"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form
          className="modal__form modal-content needs-validation"
          id="modalCustomerForm"
          noValidate
          onSubmit={handleSubmit}
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalCustomerLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href={modalIcon}></use>
                </svg>
              </div>
              <div className="modal__title__text">{modalTitleText}</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column gap-3 px-2">
              <div className="modal__form__catagory row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-6">
                      <label htmlFor="modalCustomerCode" className="form-label">
                        客戶代號*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalCustomerCode"
                        name="modalCustomerCode"
                        value={modalCustomerCode}
                        onChange={(e) => setModalCustomerCode(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="customer-modal-short-name"
                        className="form-label"
                      >
                        客戶簡稱*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="customer-modal-short-name"
                        name="modalCustomerShortName"
                        value={customerShortName}
                        onChange={(e) => setCustomerShortName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalCustomerName" className="form-label">
                        客戶名稱*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalCustomerName"
                        name="modalCustomerName"
                        value={modalCustomerName}
                        onChange={(e) => setModalCustomerName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalCustomerName" className="form-label">
                        客戶Email*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalCustomerEmail"
                        name="modalCustomerEmail"
                        value={modalEmail}
                        onChange={(e) => setModalEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-2">
                      <label htmlFor="modalPostalCode" className="form-label">
                        郵遞區號*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalPostalCode"
                        name="modalPostalCode"
                        value={modalPostalCode}
                        onChange={(e) => setModalPostalCode(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-5">
                      <label htmlFor="modalAddress" className="form-label">
                        縣市*
                      </label>
                      <Typeahead
                        id="modalCity"
                        value={modalCity}
                        size="sm"
                        onChange={(selected) => {
                          setModalCity(selected);
                          setModalDistrict([]);
                          const filteredDistrict = districtList.filter(
                            (dis) => dis.cityId === selected[0]?.value,
                          );
                          setModalDistrictOptions(
                            filteredDistrict.length > 0
                              ? filteredDistrict
                              : districtList,
                          );
                        }}
                        selected={modalCity}
                        inputProps={{required: true}}
                        options={cityList}
                        labelKey="cityName"
                        // placeholder="請輸入縣市名稱"
                        renderInput={({
                          inputRef,
                          referenceElementRef,
                          ...inputProps
                        }) => (
                          <input
                            {...inputProps}
                            className="rbt-input-main form-control rbt-input form-control-sm form-select px-1 fs-0"
                            style={{
                              fontSize: '14px',
                            }}
                            ref={(node) => {
                              inputRef(node);
                              referenceElementRef(node);
                            }}
                          />
                        )}
                        renderMenu={(results, menuProps) => (
                          <Menu
                            id={menuProps.id}
                            innerRef={menuProps.innerRef}
                            maxHeight="140px"
                            style={menuProps.style}
                          >
                            {results.map((result, index) => (
                              <MenuItem
                                option={result}
                                position={index}
                                key={index}
                              >
                                {result.cityName}
                              </MenuItem>
                            ))}
                          </Menu>
                        )}
                      />
                    </div>
                    <div className="col-5">
                      <label htmlFor="modalDistricts" className="form-label">
                        地區*
                      </label>
                      <Typeahead
                        id="modalDistrict"
                        value={modalDistrict}
                        size="sm"
                        onChange={(selected) => {
                          setModalDistrict(selected);
                        }}
                        selected={modalDistrict}
                        inputProps={{required: true}}
                        options={modalDistrictOptions}
                        labelKey="districtName"
                        // placeholder="請輸入縣市名稱"
                        renderInput={({
                          inputRef,
                          referenceElementRef,
                          ...inputProps
                        }) => (
                          <input
                            {...inputProps}
                            className="rbt-input-main form-control rbt-input form-control-sm form-select px-1 fs-0"
                            style={{
                              fontSize: '14px',
                            }}
                            ref={(node) => {
                              inputRef(node);
                              referenceElementRef(node);
                            }}
                          />
                        )}
                        renderMenu={(results, menuProps) => (
                          <Menu
                            id={menuProps.id}
                            innerRef={menuProps.innerRef}
                            maxHeight="120px"
                            style={menuProps.style}
                          >
                            {results.map((result, index) => (
                              <MenuItem
                                option={result}
                                position={index}
                                key={index}
                              >
                                {result.districtName}
                              </MenuItem>
                            ))}
                          </Menu>
                        )}
                      />
                    </div>
                    <div className="col-12">
                      <label htmlFor="modalAddress" className="form-label">
                        地址*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalAddress"
                        name="modalAddress"
                        value={modalAddress}
                        onChange={(e) => setModalAddress(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="customer-modal-longitude"
                        className="form-label"
                      >
                        經度*
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="customer-modal-longitude"
                        name="modalLongitude"
                        value={longitude}
                        onChange={(e) => {
                          let value = parseFloat(e.target.value);
                          if (Number.isNaN(value)) {
                            value = null;
                          }
                          setLongitude(value);
                        }}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label
                        htmlFor="customer-modal-latitude"
                        className="form-label"
                      >
                        緯度*
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        id="customer-modal-latitude"
                        name="modalLatitude"
                        value={latitude}
                        onChange={(e) => {
                          let value = parseFloat(e.target.value);
                          if (Number.isNaN(value)) {
                            value = null;
                          }
                          setLatitude(value);
                        }}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalContactName" className="form-label">
                        聯絡人姓名*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalContactName"
                        name="modalContactName"
                        value={modalContactName}
                        onChange={(e) => setModalContactName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalContactPhone" className="form-label">
                        聯絡人電話*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalContactPhone"
                        name="modalContactPhone"
                        value={modalContactPhone}
                        onChange={(e) => setModalContactPhone(e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalMemo" className="form-label">
                        備註
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalMemo"
                        name="modalMemo"
                        value={modalMemo}
                        onChange={(e) => setModalMemo(e.target.value)}
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalFaxId" className="form-label">
                        統編*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalFaxId"
                        name="modalFaxId"
                        value={modalFaxId}
                        onChange={(e) => setModalFaxId(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div
                    className="alert alert-warning global-invalid-feedback"
                    style={{display: invalidShow}}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-cancel"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              儲存
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export default CustomerModal;
